// extracted by mini-css-extract-plugin
export default {"layout":"layout--rDGjt","callingScreen":"callingScreen--zsK5O","purchaseDetailsPopupContent":"purchaseDetailsPopupContent--nT1t9","animation-bzdot9":"animation-bzdot9--NPmGZ"};